<template>
  <b-card>
    <div class="d-flex justify-content-between mb-2">
      <h3 v-if="!!groupData && !isLoadingGroup">{{groupData.name}}</h3>
      <div v-else></div>
      <b-button size="sm" variant="warning" @click="goToHome"> <feather-icon icon="ArrowLeftIcon" size="16" />Regresar</b-button>
    </div>
    <div v-if="!!groupData && !isLoadingGroup">

      <div class="mb-1" v-if="!!groupData.weddingID">
        <b>Identificador de boda: </b> {{groupData.weddingID}}
      </div>

      <HotelsTabs :group="groupData"/>
    </div>
    <div v-else-if="isLoadingGroup" class="text-center">
      <b-spinner variant="success"/> <br>
      Cargando información de grupo
    </div>
    <div v-else>
      <b-alert show variant="warning" class="p-1 text-center">No se encontró información del grupo</b-alert>
    </div>
  </b-card>
</template>

<script>
import HotelsTabs from '@/modules/groups/components/GroupsList/HotelsTabs'
import { mapActions } from "vuex";

export default {
  async created(){
    await this.getInit()
  },
  components: {
    HotelsTabs
  },
  data(){
    return {
      groupData: null,
      groupId: this.$route.params.id,
      isLoadingGroup: false
    }
  },
  methods:{
    ...mapActions("groups", ["fetchGroupData"]),
    async getInit(){
      this.isLoadingGroup = true
      const group = await this.fetchGroupData({id: this.groupId})
      this.groupData = group
      this.isLoadingGroup = false
    },
    goToHome(){
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'group-list' })
      }
    },
  }
}
</script>

<style>

</style>